export default __webpack_public_path__ + "static/media/game-catg-2.d12cd018.jpg";